<template>
  <!-- 輔導紀錄頁 -->
  <dir class="scrollable-container">
    <app-overlay-loading :loading="loading" />
    <evaluate-student-dialog ref="evaluateDialog" @submited="query"/>

    <v-toolbar
      :color="themeColor"
      flat>
      <span class="title">收入紀錄 (三個月內)</span>
    </v-toolbar>

    <v-data-table
      class="data-table"
      no-data-text="查無資料"
      :headers="headers"
      :items="history"
      :disable-initial-sort="true"
      hide-actions>
      <template slot="items" slot-scope="props">
        <td>{{props.item.targetName}}</td>
        <td>{{props.item.subjects}}</td>
        <td class="text-xs-right">{{props.item.duration}}</td>
        <td class="text-xs-right">{{props.item.date}}</td>

        <td class="text-xs-center">
          <v-btn
            v-if="props.item.teacherReportStatus === '未填寫'"
            @click="showEvaluateDialog(props.item)"
            color="error"
            flat
            small>
            {{props.item.teacherReportStatus}}
          </v-btn>
          <span v-else>{{props.item.teacherReportStatus}}</span>
        </td>
      </template>
    </v-data-table>
  </dir>
</template>

<script>
import {mapActions} from 'vuex';
import EvaluateStudentDialog from '../Fudao/FudaoEvaluateStudentDialog';

export default {
  components: {
    'evaluate-student-dialog': EvaluateStudentDialog
  },

  data() {
    return {
      dialog: false,
      loading: false,
      history: [],

      headers: [
        {
          text: '輔導學生',
          value: 'targetName',
          width: '200'
        },
        {
          text: '輔導科目',
          value: 'subject'
        },
        {
          text: '輔導時間',
          align: 'right',
          value: 'duration'
        },
        {
          text: '輔導日期',
          align: 'right',
          value: 'date'
        },
        {
          text: '評價狀態',
          align: 'center',
          value: 'teacherReportStatus'
        }
      ]
    };
  },

  async mounted() {
    this.query();
  },

  methods: {
    ...mapActions('fudao', {
      getFudaoHistory: 'getFudaoHistory'
    }),

    showEvaluateDialog(fudaoInfo) {
      this.$refs.evaluateDialog.open({
        fudaoId: fudaoInfo.fudaoId,
        teacherId: fudaoInfo.teacherId,
        studentId: fudaoInfo.targetId
      });
    },

    async query() {
      this.loading = true;
      try {
        this.history = await this.getFudaoHistory();
      } catch (e) {
        // TODO show error
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.data-table {
  overflow: auto;
  flex-grow: 1;
}

.data-table >>> .v-table__overflow {
  overflow: initial;
}

.data-table >>> .v-datatable.v-table td {
  white-space: nowrap;
}
</style>
